import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Github, Workflow, Zap, Database, Key, Monitor, Cpu } from 'lucide-react';

const platforms = [
  {
    name: 'Open Balancer n8n',
    description: 'Self-hosted workflow automation engine',
    url: 'https://n8n.openbalancer.com',
    icon: Workflow,
    color: 'from-pink-500 via-rose-600 to-red-600',
    enabled: true
  },
  {
    name: 'Infisical Secret Vault',
    description: 'Machine Identity n8n-server & RSA Keys',
    url: 'https://infisical.openbalancer.com',
    icon: Key,
    color: 'from-emerald-500 via-teal-600 to-cyan-600',
    enabled: true
  },
  {
    name: 'Supabase Self-Hosted',
    description: 'GoTrue Auth v2.189.0 & Postgres 17',
    url: 'https://leons-mac-mini.tailb90d8b.ts.net',
    icon: Database,
    color: 'from-emerald-600 via-green-600 to-teal-700',
    enabled: true
  },
  {
    name: 'Windows 10 OS VM',
    description: 'QEMU Web GUI & Microinvest Delta Pro',
    url: 'https://win.openbalancer.com',
    icon: Monitor,
    color: 'from-blue-600 via-indigo-600 to-purple-600',
    enabled: true
  },
  {
    name: 'Hermes3 Local LLM',
    description: 'Ollama 8B Q4_0 Zero-Cost Model API',
    url: 'https://hermes.openbalancer.com',
    icon: Cpu,
    color: 'from-purple-500 via-indigo-600 to-blue-600',
    enabled: true
  },
  {
    name: 'GitHub OpenBalancer',
    description: 'Production main repository & CI/CD',
    url: 'https://github.com/Wallesters-org/OpenBalancer',
    icon: Github,
    color: 'from-gray-700 via-gray-800 to-gray-900',
    enabled: true
  }
];

export default function PlatformLinks() {
  const handlePlatformClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
      {platforms.filter(p => p.enabled).map((platform, index) => {
        const Icon = platform.icon;
        return (
          <motion.button
            key={platform.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.08 }}
            whileHover={{ scale: 1.03, y: -2 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => handlePlatformClick(platform.url)}
            className="glass-effect p-4 rounded-xl hover:bg-white/10 transition-all text-left group border border-white/5 hover:border-primary-500/30"
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 bg-gradient-to-br ${platform.color} rounded-lg flex items-center justify-center flex-shrink-0 group-hover:shadow-lg transition-shadow border border-white/10`}>
                <Icon className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-semibold text-white group-hover:text-primary-400 transition-colors truncate">{platform.name}</h3>
                  <ExternalLink className="w-4 h-4 text-dark-400 group-hover:text-primary-400 transition-colors flex-shrink-0" />
                </div>
                <p className="text-sm text-dark-400">{platform.description}</p>
                <p className="text-xs text-dark-500 mt-1 truncate font-mono">{platform.url}</p>
              </div>
            </div>
          </motion.button>
        );
      })}
    </div>
  );
}
